import React, { useEffect, useState } from 'react';
import { ReactSession } from 'react-client-session';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import Warning from '../images/warning.png';
import Loader from '../components/loader';

function App() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
	const [loader, setLoader] = useState(false);
	const dates = sessionStorage.getItem("orderDate") || '';
    const [orderData, setorderData] = useState([]);
	const [employeeData, setEmployeeData] = useState('');
	const [showPopup, setShowPopup] = useState(false);
  	const [pendingOrderId, setPendingOrderId] = useState(null);
  	const [date, setDate] = useState(dates);
	// const [searchTerm, setSearchTerm] = useState('');
	const [approvedByFilter, setApprovedByFilter] = useState('');
    const [routeFilter, setRouteFilter] = useState('');
    const [dealerSearch, setDealerSearch] = useState('');
    const [invFilter, setInvFilter] = useState(null);
	const [allVnum, setAllVnum] = useState([]);
	const [selectedVnum, setSelectedVnum] = useState("all");


	useEffect(() => {
        const intervalId = setInterval(() => {
            if(dates && dates !== null ){
				getOrders(dates);
				//console.log('date',dates);
			}else{
				const today = new Date();
				const formattedDate = today.toLocaleDateString();
				getOrders(formattedDate);
			}
        }, 300000); // 300,000 ms = 5 minutes

        return () => clearInterval(intervalId); // cleanup on unmount
    }, []);


	const formatDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
		return formattedDate;
	};

	const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
		return formattedDate;
	};

	const changeDate = async (e) =>{
		setLoader(true);
		const date = e.target.value;
		sessionStorage.setItem("orderDate", date);
		const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
		setDate(formattedDate);

		try {
			const response = await axios.post('https://api.trucoo.in/orders/view-orders/', {date: formattedDate}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				const filterData = response.data.data.filter(datas => datas.status === 'Placed');
				setorderData(response.data.data);
				setDate(response.data.date);
			}else{
				setorderData([]);
				setDate(response.data.date);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
		setLoader(false);
	};

    const getOrders = async (date) => {
		setLoader(true);
        const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
		setDate(formattedDate);
		try {
			const response = await axios.post('https://api.trucoo.in/orders/view-orders/', {date: formattedDate}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				//const filterData = response.data.data.filter(datas => datas.status === 'Placed');
				setorderData(response.data.data);
				setDate(response.data.date);
			}else{
				setorderData([]);
				setDate(response.data.date);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
		setLoader(false);
	};

	

    const getEmployee = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/employees/all-employee/', employeeData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				const delEmp = response.data.data.filter(employee => employee.employeeType === 'logistic');
				setEmployeeData(delEmp);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	useEffect(() => {
			if(dates && dates !== null ){
				getOrders(dates);
				//console.log('date',dates);
			}else{
				const today = new Date();
				const formattedDate = today.toLocaleDateString();
				getOrders(formattedDate);
			}
			getEmployee();
	},[]);

	useEffect(() => {
		const uniqueVnum= [];
		orderData?.forEach(order => {
            const vNum = order.vNum;
            const vnumExists = uniqueVnum.some(item => item.vNum === vNum);
            if (!vnumExists && vNum) {
                uniqueVnum.push({ vNum });
            }
        });
        setAllVnum(uniqueVnum);
	}, [orderData]);


	// const openPop = (name, orderid) => {
	// 	const element = document.getElementById('popup');
    // 	if (element) {
    //   		element.style.display = 'block';
    // 	}
	// };

	// const closePop = () => {
	// 	const element = document.getElementById('popup');
    // 	if (element) {
    //   		element.style.display = 'none';
    // 	}
	// };


	const assignNow = async (e, orderid) => {
		const empId = e.target.value;
		const empName = employeeData && employeeData.filter(employee => employee.id === empId)[0].employeeName;
		
		const userConfirmed = window.confirm(`Confirm ${orderid} assign with ${empName}`);

		if(userConfirmed){

		try {
			const response = await axios.post('https://api.trucoo.in/orders/order-assign/', {empId: empId, orderId: orderid, empName:	empName}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				getOrders(date);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
		getOrders(date);
		}
	};

	const confirmRemoveOrder = (orderId) => {
		setPendingOrderId(orderId);
		setShowPopup(true);
	};

	const cancelRemoveOrder = () => {
		setShowPopup(false);
		setPendingOrderId(null);
	};

	const proceedRemoveOrder = async () => {
		try {
		  const response = await axios.post(
			'https://api.trucoo.in/orders/remove/',
			{ orderId: pendingOrderId },
			{
			  headers: {
				'Content-Type': 'application/json',
				'X-API-KEY': 'erpTrucoo',
			  },
			}
		  );
	
		  console.log(response.data);
		  if (response.data.status === 'success') {
			getOrders(date);
		  }
		} catch (error) {
		  console.error('Error:', error.response || error.message);
		} finally {
		  setShowPopup(false);
		  setPendingOrderId(null);
		}
		getOrders(date);
	};


//console.log("order data",orderData)

const filteredOrders = orderData.length > 0
  ? orderData.filter(order => {

      const approvedByMatches = !approvedByFilter
        ? true
        : approvedByFilter === 'Approved'
        ? order.status === 'Approved' 
        : order.status === 'Placed';

    
      const routeMatches = !routeFilter || order.dealerData.routes === routeFilter;

      const dealerMatches = !dealerSearch || order.dealerData.dealer.toLowerCase().includes(dealerSearch.toLowerCase());

      const invMatches = !invFilter || order.invoice === invFilter;

	  const vnumMatches = selectedVnum === "all" || order.vNum === selectedVnum;

      return approvedByMatches && routeMatches && dealerMatches && invMatches && vnumMatches;
    })
  : [];

  //console.log("Filtered Orders", orderData);

  let cratesTotal = 0;
  let qtyTotal = 0;
  let weightTotal = 0;
  let orderTotal = 0;


return(
<>
{loader && <Loader /> }
	<div class="overlay" style={{display: showPopup ? 'flex' : 'none'}}>
    	<div class="popup">
			<img src={Warning} width='90px' />
			<h4 class="text-bold mt-2 mb-2">Delete Order</h4>
      		<p>Would you like to delete this Order?</p>
			<button class="btn btn-success mx-3" onClick={proceedRemoveOrder}><i class="fa fa-trash"></i></button>
      		<button class="btn btn-danger mx-3"  onClick={cancelRemoveOrder} ><i class="fa fa-close"></i></button>
    	</div>
  	</div>
    <Header />
    <Sidebar />

	{/* <div class="popup-overlay" id="popup">
    	<div class="popup" id="popup">
        	<span class="close" onClick={closePop}>&times;</span>
        	<div class="popup-content">
            	<p>Assign Employee!</p>
            	<p id="popupContent"></p>
            	<button class="btn btn-success" style={{marginRight: '10px'}} onClick={() => {setPopState(true)}}>Confirm</button>
            	<button class="btn btn-secondary" onClick={closePop}>Cancel</button>
        	</div>
    	</div>
	</div> */}

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">All Orders</h4>
				  <hr />
				 
				 <div class="row">
					<div class="col-md-2">
						<label className='form-label'>Date</label>
				   		<input type="date" class="form-control" value={formatDate(date)} onChange={(e)=>changeDate(e)} />  
					</div>
					<div class="col-md-2">
						<label className='form-label'>Search Dealer</label>
						<input type="text" placeholder="Search Dealer" className="form-control" value={dealerSearch} onChange={(e) => setDealerSearch(e.target.value)} />
					</div>
  				 	<div class="col-md-2">
						<label className='form-label'>Approval</label>
						<select
							className="form-control"
							value={approvedByFilter}
							onChange={(e) => setApprovedByFilter(e.target.value)}
						>
							<option value="">Both</option>
							<option value="Approved">Approved</option>
							<option value="Placed">Not Approved</option>
						</select>
					</div>
					<div class="col-md-2">
						<label className='form-label'>Invoice</label>
						<select
							className="form-control"
							value={invFilter}
							onChange={(e) => setInvFilter(e.target.value)}
						>
							<option value={null}>Both</option>
							<option value="yes">Yes</option>
							<option value="no">No</option>
						</select>
				 	</div>
					<div class="col-md-2">
						<label className='form-label'>Route</label>
						<select
							className="form-control"
							value={routeFilter}
							onChange={(e) => setRouteFilter(e.target.value)}
						>
							<option value="">All Routes</option>
							{[...new Set(
							orderData.length > 0 ? orderData.map(order => order.dealerData.routes) : []
							)].map((route, idx) => (
							<option key={idx} value={route}>
							{route}
							</option>
							))}
						</select>
					</div>
					<div class="col-md-2">
						<label className='form-label'>Vehicle Number</label>
						<select
							className="form-control"
							value={selectedVnum}
							onChange={(e) => setSelectedVnum(e.target.value)}
						>
							<option value="all">All Vehicles</option>
                            {allVnum?.map((vnum, index) => (
                                <option key={index} value={vnum.vNum}>{vnum.vNum}</option>
                            ))}
						</select>
					</div>
					
					
				</div>
  	

				</div>
				<div className="box-body">
					<div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 320px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                        <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
						<thead>
							<tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
								<th width="2%" rowSpan={2}>S.No</th>
								<th rowSpan={2}>Date</th>
								
								<th rowSpan={2}>Type</th>
								<th rowSpan={2}>Dealer</th>
								<th rowSpan={2}>Route</th>
								<th rowSpan={2}>Place</th>
								<th rowSpan={2}>Crates</th>
								<th rowSpan={2}>QTY</th>
								<th rowSpan={2}>L/KGs</th>
								<th rowSpan={2}>Order Total</th>
								<th rowSpan={2}>Order By</th>
								<th rowSpan={2}>Approved By</th>
								<th rowSpan={2}>Invoice</th>
								<th colSpan={3} rowSpan={2} class="text-center">Options</th>
								<th colSpan={3} class="text-center">Timing</th>
							</tr>
							<tr className="text-dark text-center" style={{ position: 'sticky', top: 25, zIndex: 2, backgroundColor: '#f8f9fa' }}>
								<th>Placed</th>
								<th>Approved</th>
								<th>Invoiced</th>
							</tr>
						</thead>
						<tbody>
							{filteredOrders.length > 0 ? 
							<>
							{filteredOrders.map((order, index) => {

								cratesTotal += order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty), 0);
								qtyTotal += order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item.crates), 0);
								weightTotal += order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.crates * (item?.weight/1000)), 0);
								orderTotal += Number(order.totalPayment);
							return (
							<tr key={index} style={{whiteSpace: 'nowrap', backgroundColor: order.type === 'challan' ? '#f4f4f4ff' : '#ffffff'}}>
								<td class="text-center">{index+1}</td>
								<td class="text-center">{formatViewDate(order.orderDate)}</td>
								<td class="text-center">{order?.type?.toUpperCase()} </td>
								<td >{order.dealerData.dealer} </td>
								<td >{order.dealerData.routes} </td>
								<td >{order.dealerData.locations} </td>
								<td class='text-end'>{order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty), 0).toFixed(2)}</td>
								<td class='text-end'>{order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item.crates), 0).toFixed(2)}</td>
								<td class='text-end'>{order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.crates * (item?.weight/1000)), 0).toFixed(2)}</td>
								<td class='text-end'>{(Number(order.totalPayment)).toFixed(2)}</td>
                                <td >{order.employeeData.employeeName}</td>
                                <td  class={order.status === 'Placed' ? 'text-danger text-center' : 'text-success text-center'}>{order.status === 'Placed' ? 'Waiting' : order?.approved?.employeeName }</td>
								<td  class={order.invoice==='no' ? 'text-danger text-center' : 'text-success text-center'} >{order.invoice==='no'? 'No':'Yes'}</td>
								
								<td>
                                    <a href={`/order-details?id=${order.orderId}`} class="btn btn-sm btn-success" style={{textAlign: 'center'}}>View</a>
                                </td>
								
								<td>
									{order.invoice==='no' ?
									 <a href={`edit-order?id=${order.orderId}`} className='btn btn-sm btn-warning'><i class="fa fa-edit"></i></a>
									 :
									  <button disabled className='btn btn-sm btn-warning'><i class="fa fa-edit"></i></button>
									}
								</td>
								<td>
                                    {order.invoice==='no' ?
									   <button onClick={()=> {confirmRemoveOrder(order.orderId)}} class="btn btn-sm btn-danger text-white" style={{textAlign: 'center', color: 'red'}}><i class="fa fa-trash"></i></button>
									:
									<button disabled class="btn btn-sm btn-danger" style={{textAlign: 'center', color: 'red'}}><i class="fa fa-trash"></i></button>
									  
									}
								</td>

								<td>{order?.orderTime}</td>
								<td>{order?.approvedTime}</td>
								<td>{order?.invoiceTime}</td>
							</tr>
							
							)}
							
							)}
							<tr>
								<th colSpan={6} class='text-start'>Total</th>
								<th class='text-end'>{cratesTotal.toFixed(2)}</th>
								<th class='text-end'>{qtyTotal.toFixed(2)}</th>
								<th class='text-end'>{weightTotal.toFixed(2)}</th>
								<th class='text-end'>{orderTotal.toFixed(2)}</th>
								<th colSpan={8}></th>
							</tr>

							</>

							:(
								<tr>
									<td colSpan={12} class='text-center p-4'>No orders available</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	{/* <Footer /> */}
</>
);
}

export default App;